<template>
  <div>
    <communications-send-modal
      :company-name="companyName"
      ref="modal"
    />
    <communications-list 
      :communications="communications" 
      :direction="direction" 
      :title="title" 
      :investor-id="investorId"
      :company-name="companyName"
      :communication-type="communicationType"/>
    <button @click="$refs.modal.show()" class="btn btn-primary">Message Company</button>
  </div>
</template>

<script>
import CommunicationsSendModal from 'communications_send_modal.vue'
import CommunicationsList from 'communications_list.vue'

export default {
  props: [ "communications", "direction", "title", "investor-id", "company-name", "communication-type" ],
  components: { CommunicationsSendModal, CommunicationsList },
}
</script>

